const typographyMyComp = {
  company: 'Minha Empresa',
  profileError: 'Aguarde o arquivo subir',
  user: 'Número de Usuários:',
  userValue: '6 (60%)',
  plan: 'Consumo de dados:',
  planValue: '32,5 GB (73%)',
  contract: 'Plano Contratado:',
  contractValue: '10 users/50 GB',
  formLabelTitle: 'Contratação do plano:',
  formLabelValue: '10/08/2019 às 08:23 (3 meses)'
};

export default typographyMyComp;
